var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2393",
    "data-name": "Rectangle 2393",
    width: 38,
    height: 38,
    rx: 5,
    transform: "translate(-0.25)",
    fill: "#fff1d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(0.25)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube_1_",
    "data-name": "youtube (1)",
    transform: "translate(-0.25 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5200",
    "data-name": "Path 5200",
    d: "M28.5,38H9.5A9.5,9.5,0,0,1,0,28.5V9.5A9.5,9.5,0,0,1,9.5,0h19A9.5,9.5,0,0,1,38,9.5v19A9.5,9.5,0,0,1,28.5,38",
    transform: "translate(0 0)",
    fill: "red",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5201",
    "data-name": "Path 5201",
    d: "M17.849,10.746h10.71A5.374,5.374,0,0,0,29.107.027C28.924.017,28.744,0,28.559,0H9.52A9.536,9.536,0,0,0,0,9.551v19.1A17.88,17.88,0,0,1,17.849,10.746",
    transform: "translate(0 0)",
    fill: "#ff5a51",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5202",
    "data-name": "Path 5202",
    d: "M39.839,24.8a9.554,9.554,0,1,0,9.339,9.552V15.25A9.447,9.447,0,0,1,39.839,24.8",
    transform: "translate(-11.179 -5.905)",
    fill: "#d5002c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5203",
    "data-name": "Path 5203",
    d: "M22.748,16.932a1.145,1.145,0,0,0-1.181-.026,1.2,1.2,0,0,0-.6,1.042v14.83a1.2,1.2,0,0,0,.6,1.042,1.145,1.145,0,0,0,1.181-.026L34.53,26.381a1.208,1.208,0,0,0,0-2.033L22.748,16.932Z",
    transform: "translate(-7.772 -6.364)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.724376270819a60334ba42b1b5a8d7d4.svg";
export { ForwardRef as ReactComponent };